// extracted by mini-css-extract-plugin
export default {"headerContainer":"RiskListHeader_headerContainer__RMjob"};